export default {
  'notifications.title': 'Notificaciones',
  'notifications.drawerTitle': 'NOTIFICACIONES',
  'notifications.empty': 'No tienes notificaciones',
  'notifications.unread': 'sin leer',
  'notifications.markAsRead': 'Marcar como leída',
  'notifications.markAllAsRead': 'Marcar todas como leídas',
  'notifications.markAsReadShort': 'Marcar leídas',
  'notifications.deleteAll': 'Eliminar todo',
  'notifications.toggleDetails.more': 'Ver más detalles',
  'notifications.toggleDetails.less': 'Ver menos detalles',
  'notifications.fileGenerated': 'Archivo generado',
  'notifications.remove': 'Eliminar notificación',
  'notifications.taskNumber': 'Número de tarea',
  'notifications.taskTitle': 'Título de tarea',
  'notifications.listName': 'Lista',
  'notifications.entityName': 'Entidad',
  'notifications.company': 'Empresa',
  'notifications.environment': 'Ambiente',
  'notifications.message': 'Mensaje',
  'notifications.operation': 'Operación',
  'notifications.operation.export': 'EXPORTACIÓN',
  'notifications.operation.import': 'IMPORTACIÓN',
  'notifications.operation.purge': 'BORRAR',
  'notifications.status': 'Estado',
  'notifications.fileName': 'Archivo',
  'notifications.fileSize': 'Tamaño',
  'notifications.expiration': 'Expira',
  'notifications.company': 'Empresa',
  'notifications.environment': 'Ambiente',
  'notifications.processInstanceName': 'Solicitud',
  'notifications.time': 'Tiempo',
  'notifications.loadingMore': 'Cargando más notificaciones...',
  'notifications.endOfList': 'No hay más notificaciones',
  'notifications.processInstanceId': 'Instancia',
  'notifications.processEvents.generic.label': 'Evento de proceso',
  'notifications.processEvents.generic.cta': 'Ver solicitud',
  'notifications.processEvents.newTaskAssigned.label': 'Nueva tarea asignada',
  'notifications.processEvents.newTaskAssigned.cta': 'Abrir solicitud',
  'notifications.processEvents.newTaskAssigned.title': 'Nueva tarea asignada',
  'notifications.processEvents.newTaskAssigned.body': 'Se asignó una nueva tarea en tu bandeja.',
  'notifications.processEvents.newComment.label': 'Nuevo comentario',
  'notifications.processEvents.newComment.cta': 'Ver comentario',
  'notifications.processEvents.newComment.title': 'Nuevo comentario',
  'notifications.processEvents.newComment.body': 'Tienes un nuevo comentario en tu solicitud.',
  'notifications.processEvents.newComment.creator': 'Autor',
  'notifications.processEvents.newComment.date': 'Fecha del comentario',
  'notifications.processEvents.newComment.comment': 'Comentario',
  'notifications.processEvents.newComment.attachments': 'Adjuntos',
  'notifications.category.entity': 'Entidad',
  'notifications.category.list': 'Lista',
  'notifications.category.process': 'Proceso',
  'notifications.category.task': 'Tarea',
  'notifications.category.comment': 'Comentario',
  'notifications.category.chat': 'Chat',
  'notifications.category.bulk': 'Lotes',
  'notifications.category.alert': 'Alerta',
  'notifications.category.system': 'Sistema',

  // Status values
  'notifications.status.completed': 'Completado',
  'notifications.status.failed': 'Fallido',
  'notifications.status.inProgress': 'En progreso',
  'notifications.status.queued': 'En cola',
  'notifications.status.cancelled': 'Cancelado',
  'notifications.status.skipped': 'Omitido',
  'notifications.status.paused': 'En pausa',
  'notifications.status.processingItems': 'Procesando ítems',
  'notifications.status.unknown': 'Desconocido',

  // Priority levels
  'notifications.priority.high': 'Alta',
  'notifications.priority.normal': 'Normal',
  'notifications.priority.low': 'Baja',

  // Entity export notifications
  'notifications.export.completed.title': 'Exportación completada',
  'notifications.export.completed.message':
    'La exportación de "{entityName}" se ha completado exitosamente',
  'notifications.export.failed.title': 'Error en exportación',
  'notifications.export.failed.message': 'La exportación de "{entityName}" ha fallado',
  'notifications.export.inprogress.title': 'Exportación en progreso',
  'notifications.export.inprogress.message':
    'La exportación de "{entityName}" está siendo procesada',
  'notifications.export.queued.title': 'Exportación en cola',
  'notifications.export.queued.message':
    'La exportación de "{entityName}" está en cola de procesamiento',

  // Entity import notifications
  'notifications.import.completed.title': 'Importación completada',
  'notifications.import.completed.message':
    'La importación de "{entityName}" se ha completado exitosamente',
  'notifications.import.failed.title': 'Error en importación',
  'notifications.import.failed.message': 'La importación de "{entityName}" ha fallado',
  'notifications.import.inprogress.title': 'Importación en progreso',
  'notifications.import.inprogress.message':
    'La importación de "{entityName}" está siendo procesada',

  // Operations text
  'notifications.operationType.export': 'Exportación',
  'notifications.operationType.import': 'Importación',
  'notifications.operationType.purge': 'Borrado',
  'notifications.operationType.refreshDataset': 'Actualización de datos',
  'notifications.operationType.default': 'Operación',

  // Status text
  'notifications.statusText.pending': 'En cola',
  'notifications.statusText.processing': 'En progreso',
  'notifications.statusText.processed': 'Completado',
  'notifications.statusText.failed': 'Fallido',
  'notifications.statusText.error': 'Error',
  'notifications.statusText.cancelled': 'Cancelado',
  'notifications.statusText.skipped': 'Omitido',
  'notifications.statusText.unknown': 'Desconocido',

  // Generic notifications
  'notifications.generic.title': 'Nueva notificación',
  'notifications.generic.message': 'Se ha recibido una nueva notificación',

  // Actions
  'notifications.action.download': 'Descargar archivo',
  'notifications.action.view': 'Ver detalles',
  'notifications.action.retry': 'Reintentar',

  // Messages
  'notifications.download.success': 'Descarga iniciada correctamente',
  'notifications.download.error': 'Error al descargar el archivo',

  // File messages
  'notifications.file.expires': 'Expira',

  // List export notifications
  'notifications.list.export.completed.title': 'Exportación de lista completada',
  'notifications.list.export.completed.message':
    'La exportación de la lista "{listName}" se ha completado exitosamente',
  'notifications.list.export.failed.title': 'Error en exportación de lista',
  'notifications.list.export.failed.message': 'La exportación de la lista "{listName}" ha fallado',
  'notifications.list.export.inprogress.title': 'Exportación de lista en progreso',
  'notifications.list.export.inprogress.message':
    'La exportación de la lista "{listName}" está siendo procesada',
  'notifications.list.export.queued.title': 'Exportación de lista en cola',
  'notifications.list.export.queued.message':
    'La exportación de la lista "{listName}" está en cola de procesamiento',

  // List import notifications
  'notifications.list.import.completed.title': 'Importación de lista completada',
  'notifications.list.import.completed.message':
    'La importación de la lista "{listName}" se ha completado exitosamente',
  'notifications.list.import.failed.title': 'Error en importación de lista',
  'notifications.list.import.failed.message': 'La importación de la lista "{listName}" ha fallado',
  'notifications.list.import.inprogress.title': 'Importación de lista en progreso',
  'notifications.list.import.inprogress.message':
    'La importación de la lista "{listName}" está siendo procesada',

  // Report export notifications
  'notifications.report.export.completed.title': 'Exportación de reporte completada',
  'notifications.report.export.completed.message':
    'La exportación del reporte "{reportName}" se ha completado exitosamente',
  'notifications.report.export.failed.title': 'Error en exportación de reporte',
  'notifications.report.export.failed.message':
    'La exportación del reporte "{reportName}" ha fallado',
  'notifications.report.export.failed.messageDetail':
    'La exportación del reporte "{reportName}" ha fallado: {observations}',
  'notifications.report.export.inprogress.title': 'Exportación de reporte en progreso',
  'notifications.report.export.inprogress.message':
    'La exportación del reporte "{reportName}" está siendo procesada',
  'notifications.report.export.queued.title': 'Exportación de reporte en cola',
  'notifications.report.export.queued.message':
    'La exportación del reporte "{reportName}" está en cola de procesamiento',
  'notifications.report.export.cancelled.title': 'Exportación de reporte cancelada',
  'notifications.report.export.cancelled.message':
    'La exportación del reporte "{reportName}" ha sido cancelada',

  'notifications.category.report': 'Reporte',
  'notifications.category.document': 'Documentos',
  'notifications.category.configuration': 'Configuración',

  // Document Manager bulk export notifications
  'notifications.documentExport.completed.title': 'Exportación de documentos lista',
  'notifications.documentExport.completed.message':
    'La exportación {taskNumber} se ha completado. Ya puedes descargar el ZIP.',
  'notifications.documentExport.failed.title': 'Error en exportación de documentos',
  'notifications.documentExport.failed.message': 'La exportación {taskNumber} ha fallado',
  'notifications.documentExport.failed.messageDetail':
    'La exportación {taskNumber} ha fallado: {observations}',
  'notifications.documentExport.inprogress.title': 'Exportación de documentos en progreso',
  'notifications.documentExport.inprogress.message':
    'La exportación {taskNumber} está generando el ZIP',
  'notifications.documentExport.queued.title': 'Exportación de documentos en cola',
  'notifications.documentExport.queued.message':
    'La exportación {taskNumber} está en cola de procesamiento',

  // Chat notifications
  'notifications.chat.newMessageTitle': 'Nuevo mensaje de {userName}',
  'notifications.chat.previewFallback': 'Tienes un nuevo mensaje en el chat de soporte.',
  'notifications.chat.senderFallback': 'Automy',
  'notifications.chat.threadLabel': 'Nuevo mensaje',
  'notifications.chat.openThread': 'Abrir chat',
  'notifications.chat.kind.whatsapp': 'WhatsApp',
  'notifications.chat.kind.email': 'Correo',
  'notifications.bulk.open': 'Ver lote',
  'notifications.importance.high': 'Alta',
  'notifications.chat.threadId': 'ID del hilo',
  'notifications.chat.lastUpdate': 'Última actualización',
  'notifications.chat.status.pending': 'Pendiente',
  'notifications.chat.status.active': 'Activo',
  'notifications.chat.status.lookingForAgent': 'Buscando agente',
  'notifications.chat.status.closed': 'Cerrado',
  'notifications.chat.status.archived': 'Archivado',
};
